export class ChipExpression {
  isGroup = false;
}

export class SimpleChipExpression extends ChipExpression {
  keyword: string;
  operator: string;
  operands: string[];

  constructor(keyword?: string, operator?: string, operands?: string[]) {
    super();
    this.keyword = keyword;
    this.operator = operator;
    this.operands = operands;
  }
}

export class ExpertChipExpression extends SimpleChipExpression {
  logicalOp: string;

  constructor(keyword?: string, operator?: string, operands?: string[], logicalOp?: string) {
    super(keyword, operator, operands);
    this.logicalOp = logicalOp;
  }
}

export class GroupChipExpression extends ChipExpression {
  group: SimpleChipExpression[];
  logicalOp: string;

  constructor(group: SimpleChipExpression[], logicalOp?: string) {
    super();
    this.group = group;
    this.isGroup = true;
    this.logicalOp = logicalOp;
  }
}

export function mergeChips(
  existingChips: any[] = [],
  otherChips: any[] = [],
  logicalOp: string = 'AND'
) {
  const result = [].concat(existingChips);
  for (const chip of otherChips) {
    if (result.length > 0 && !chip.logicalOp) {
      // consider applying default operation if output array is not empty and chip doesn't have logicalOp by itself
      chip.logicalOp = logicalOp;
    }
    result.push(chip);
  }
  return result;
}

export function jsonFormattedFilter(filter: any, queryStruct: any) {
  let updatedFilter = null;
  if (filter && filter.length > 0) {
    updatedFilter = filter.map(item => {
      return {
        op: item.operator === '~' ? '=' : item.operator === '!~' ? '!=' : item.operator,
        logic: item.logicalOp,
        tag: item.keyword.trim(),
        expression: item.operands[0],
        pattern: item.operator === '~' || item.operator === '!~' ? true : false
      };
    });
  }
  queryStruct.queries[0].filter = updatedFilter;
}
